import { profile } from "../data/profile";
import { useI18n } from "../i18n/LanguageContext";
import styles from "./Footer.module.css";

export function Footer() {
  const { t, ui } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <p className={styles.copy}>
          © {year} {t(profile.name)} — {t(profile.role)}
        </p>
        <p className={styles.built}>{ui.footer.built}</p>
      </div>
    </footer>
  );
}
